import React from 'react'

import BkFlowRoomCardUpSellsCard from './BkFlowRoomCardUpSellsCard'

import _ from 'lodash'

const BkFlowRoomCardUpSellsCards = props => {
  const {
    roomGroup,
    currentUpSells,
    totalNights,
    selectedRoomRatePrice,
    handleUpgradeEvent,
  } = props

  const totalUpSells = currentUpSells.length

  let renderUpSellCards = []

  for (const upSellKey in currentUpSells) {
    const currentUpSell = currentUpSells[upSellKey]

    renderUpSellCards.push(
      <BkFlowRoomCardUpSellsCard
        key={'room-upsell-' + currentUpSell.roomTypeCode + '-' + currentUpSell.ratePlanCode + '-' + roomGroup}
        currentUpSell={currentUpSell}
        roomGroup={roomGroup}
        totalNights={totalNights}
        selectedRoomRatePrice={selectedRoomRatePrice}
        handleUpgradeEvent={handleUpgradeEvent}
        totalUpSells={totalUpSells}
      />
    )
  }

  return (
    <div className="bk-flow-room__card-upsells-cards">
      { !_.isEmpty(renderUpSellCards) ?
        renderUpSellCards
      :
        <p className="u-remove-margin u-txt-center">There are currently no upgrades available for this room / rate.</p>
      }
    </div>
  )
}

export default BkFlowRoomCardUpSellsCards



// WEBPACK FOOTER //
// ./src/components/room/upsells/BkFlowRoomCardUpSellsCards.js